/**
* @description
* # name controller --> learningObjetivesListController
* # As Controller --> learningObjetivesList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class learningObjetivesListController {
	constructor($scope,levelsServices,coresServices,learningObjetivesServices,ngNotify,UserInfoConstant,$state,$filter,) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.levelsServices = levelsServices.services
		this.coresServices = coresServices.services
		this.learningObjetivesServices = learningObjetivesServices.services
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.levelSelect = null
		this.$scope.coreSelect = null
		this.$scope.code = null
		

		$scope.UserInfoConstant = UserInfoConstant;
		$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.USER_ID = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		const params = {
			concept_id: this.conceptId
		}

		this.learningObjetives(params)
		this.getCores(params)
	}
	
	learningObjetives(params){
		this.learningObjetivesServices.getLearningObjetives(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.learningObejtives = []
				this.learningObejtivesList = dataReturn.results;
				for (let i in this.learningObejtivesList){
					this.learningObejtives.push({
						title: this.learningObejtivesList[i].ds_name,
						id_code: this.learningObejtivesList[i].id_code,
						cod: this.learningObejtivesList[i].ds_code,
						coreName: this.learningObejtivesList[i].core ? this.learningObejtivesList[i].core.ds_name : null,
						badges: [
							{
								label: ( (this.learningObejtivesList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.learningObejtivesList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getCores(params){
		this.coresServices.getCores(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.coresList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	onClick(item){
		this.learningObjetiveId=item.id_code;
		this.code = item.cod;
		this.learningObjetiveName=item.title;
		this.getDetailsFunction({learning_objectives_id:this.learningObjetiveId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.learningObjetivesServices.getLearningObjetiveDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.learningObejtive = dataReturn.results;
				this.$scope.coreSelect = this.learningObejtive.id_core
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({learning_objectives_id : this.learningObjetiveId});
		
	}

	saveEdit(){
		if(this.learningObjetiveName === null || this.learningObjetiveName === '') {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.code === null) {
			this.ngNotify.set('Indique código','warn')
			return
		}

		if(this.$scope.coreSelect === null) {
			this.ngNotify.set('Seleccione un Núcleo','warn')
			return
		}
		
		const params = {
			learning_objectives_id: this.learningObjetiveId,
			name: this.learningObjetiveName,
			code: this.code,
			user_id: this.USER_ID,
			core_id: this.$scope.coreSelect
		}

		this.learningObjetivesServices.updateLearningObjetives(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Obejtivo de Aprendizaje','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de Obejtivo de Aprendizaje se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de Obejtivo de Aprendizaje ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
learningObjetivesListController.$inject=['$scope', 'levelsServices', 'coresServices', 'learningObjetivesServices', 'ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/learningObjetives/list/learningObjetivesListController.js